import {html, LitElement} from '@isceco/widget-library2/external/lit'
import GasPopupCss from './GasPopupCss.js'
import '@isceco/widget-library2/basic-elements/Popup/Popup.js'

export class GasPopup extends LitElement {

  static get styles() {
    return [GasPopupCss]
  }

  static get properties() {
    return {
      left: {type: Boolean},
      helpText: {type: String, attribute: 'help-text'}
    }
  }

  connectedCallback() {
    super.connectedCallback()
    this.visible = true
    this.fixed = true
  }

  render() {
    if (isEmpty(this.helpText)) {
      return html`
        <div class="popup ${this.left ? 'left' : 'right'} ${this.visible ? '' : 'hidden'}">
          <slot></slot>
        </div>

        <div class="line"
             style="${this.lineStyle}"
             ?hidden="${!this.visible}"></div>
      `
    } else {
      return html`
        <div class="popup ${this.left ? 'left' : 'right'} ${this.visible ? '' : 'hidden'}"
             @mouseenter="${_ => this.showHelpText(true)}"
             @mouseleave="${_ => this.showHelpText(false)}">
          <slot></slot>

          <isceco-popup class="helptext" direction="up">
            <div slot="wrapper"></div>
            <div slot="content">
              ${this.helpText}
            </div>
          </isceco-popup>
        </div>

        <div class="line"
             style="${this.lineStyle}"
             ?hidden="${!this.visible}"></div>
      `
    }
  }

  show = element => {
    this.visible = true
    this.position(element)
  }

  hide = () => {
    if (!this.fixed) {
      this.visible = false
      this.requestUpdate()
    }
  }

  toggle = element => {
    if (this.fixed) {
      this.fixed = false
      this.hide()
    } else {
      this.fixed = true
      this.show(element)
    }
  }

  position = element => {
    if (this.visible) {
      const targetRect = element.getBoundingClientRect()
      const xTarget = targetRect.x + targetRect.width / 2
      const yTarget = targetRect.y + targetRect.height / 2

      const popupRect = this.shadowRoot.querySelector('.popup').getBoundingClientRect()
      const xPopup = this.left ? popupRect.x : popupRect.x + popupRect.width
      const yPopup = popupRect.y + popupRect.height / 2

      const lineHorizontal = xTarget < xPopup ? 'left' : 'right'
      const lineVertical = yTarget < yPopup ? 'bottom' : 'top'
      const lineX = Math.min(xTarget, xPopup)
      const lineY = Math.min(yTarget, yPopup)
      const lineWidth = Math.abs(xTarget - xPopup)
      const lineHeight = Math.abs(yTarget - yPopup)

      this.lineStyle = `
        left: ${lineX}px;
        top: ${lineY}px;
        width: ${lineWidth}px;
        height: ${lineHeight}px;
        border-${lineHorizontal}: 2px solid var(--border-color);
        border-${lineVertical}: 2px solid var(--border-color);
      `

      this.requestUpdate()
    }
  }

  showHelpText = show => {
    const elem = this.shadowRoot.querySelector(`.helptext`)
    if (show) {
      elem._show()
    } else {
      elem._hide()
    }
  }
}

customElements.define('gasmonitoring-popup', GasPopup)
